import { connectedAccountsStore } from '../store/store';
export function getErrorConnectBasic() {
    var store = connectedAccountsStore();
    if (store.connectBasicState.advancedChecked) {
        return false;
    }
    return store.connectBasicState.emailAddress === '' || store.connectBasicState.password === '';
}
//# sourceMappingURL=getErrorConnectBasic.js.map